import { createNullableProvideInject } from '../utils/provide-inject'

export const [provideAppRootElementSelector, injectAppRootElementSelector] =
  createNullableProvideInject<string>('appRootElementSelector')
